module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    attrs: {
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "primary",
    attrs: {
      "pt0": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('h6', {
    staticClass: "white--text"
  }, [_vm._v("Anular Facturas")])])], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Codigo",
      "dark": ""
    },
    model: {
      value: (_vm.codigotabulacion),
      callback: function($$v) {
        _vm.codigotabulacion = $$v
      },
      expression: "codigotabulacion"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mt-3": ""
    }
  }, [_c('v-btn', {
    staticClass: "print blue darken-4",
    attrs: {
      "dark": ""
    },
    on: {
      "click": _vm.buscar
    }
  }, [_vm._v("\n             Buscar")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mt-3": ""
    }
  }, [(!_vm.activo) ? _c('v-btn', {
    staticClass: "print blue darken-4",
    attrs: {
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.activo = !_vm.activo
      }
    }
  }, [_vm._v("\n             Scanear")]) : _vm._e(), _vm._v(" "), (_vm.activo) ? _c('v-btn', {
    staticClass: "print blue darken-4",
    attrs: {
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.activo = !_vm.activo
      }
    }
  }, [_vm._v("\n             Cerrar")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(_vm.activo) ? _c('StreamBarcodeReader', {
    attrs: {
      "name": "codigo"
    },
    on: {
      "decode": _vm.onDecode,
      "loaded": _vm.onLoaded
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('layout', [_c('v-flex', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Cliente")]), _vm._v(" "), _c('th', [_vm._v("Fecha")]), _vm._v(" "), _c('th', [_vm._v("Total")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.facturas.results), function(factura) {
    return _c('tr', [_c('td', [_c('v-btn', {
      staticClass: "blue--text text--darken-2",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.editarfactura(factura)
        }
      }
    }, [_c('v-icon', [_vm._v("cancel")])], 1)], 1), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [_vm._v(_vm._s(factura.cliente_name))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(factura.fecha)))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [_vm._v("Q. " + _vm._s(factura.total.toFixed(2)))])])
  }), 0)])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [(_vm.facturas.previous) ? _c('v-btn', {
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "primary": ""
    },
    on: {
      "click": function($event) {
        return _vm.prev(_vm.facturas.previous)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("skip_previous")])], 1) : _vm._e(), _vm._v(" "), (_vm.facturas.next) ? _c('v-btn', {
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "primary": ""
    },
    on: {
      "click": function($event) {
        return _vm.next(_vm.facturas.next)
      }
    }
  }, [_c('v-icon', [_vm._v("skip_next")])], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6085c785"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AnularFacturas.vue
// module id = 439
// module chunks = 1